import { useRef } from 'react'
import styles from './TopStrengths.module.scss'
import Button from 'components/common/Button/Button'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

const TopStrengths: React.FC = () => {
  const refs = [
    useRef<HTMLDivElement | null>(null),
    useRef<HTMLDivElement | null>(null),
    useRef<HTMLDivElement | null>(null),
  ]
  const isVisibleArray = refs.map((ref) => useElementVisible(ref, 0.1))

  const strengthsList = [
    {
      number: '01',
      titleEn: 'AI & Cloud Native',
      titleJa: 'AI駆動開発ならびにクラウドサービスに精通',
      text: 'AI駆動開発×クラウドネイティブ×プラットフォームエンジニアリングを融合し、最新のクラウドサービスを活用。既存システムの最適化やクラウド移行、セキュリティ強化まで、企業の課題に応じたIT基盤を構築し、ビジネス成長を支援します。',
    },
    {
      number: '02',
      titleEn: 'Security',
      titleJa: 'エンタープライズ・セキュリティ要件に対応',
      text: '金融機関やヘルスケア領域など、高度なセキュリティを求められる分野に対応。データの機密性・完全性・可用性を確保するため、最新のセキュリティ技術を活用し、多層的な防御を構築。 暗号化やインシデント対応を含む対策を施し、ビジネス継続性と信頼性を両立した安全なシステムを実現します。',
    },
    {
      number: '03',
      titleEn: 'Innovative',
      titleJa: 'デザインとテクノロジーの統合',
      text: 'UX/UIデザインを基軸に、顧客体験を最大化するプロダクト開発を支援。 デザインとテクノロジーを融合し、スケーラブルで直感的なシステムを構築。 スピードと品質を両立し、持続的なプロダクト成長とビジネスの成功を実現します。',
    },
  ]

  return (
    <section className={styles.topStrengths}>
      <h2
        className={`${styles.topStrengths__title} ${animationStyles.fade} ${
          isVisibleArray[0] ? animationStyles.fadeOn : ''
        }`}
        ref={refs[0]}
      >
        i3DESIGNの強み
      </h2>

      {strengthsList.map((strengthsList, index) => (
        <section
          key={index}
          className={`${styles.strength} ${animationStyles.fade} ${
            isVisibleArray[index] ? animationStyles.fadeOn : ''
          }`}
          ref={refs[index]}
        >
          <div className={styles.strength__num}>({strengthsList.number})</div>
          <div className={styles.strength__cts}>
            <h3 className={styles.strength__cts__title}>
              <span className={styles.strength__cts__title__en}>{strengthsList.titleEn}</span>
              <span className={styles.strength__cts__title__ja}>{strengthsList.titleJa}</span>
            </h3>
            <p className={styles.strength__cts__text}>{strengthsList.text}</p>
          </div>
        </section>
      ))}

      <div className={styles.strength__contact}>
        <div className={styles.inner}>
          <p className={styles.strength__contact__text}>
            貴社が解決したい課題、達成したいミッションをお聞かせください。
          </p>
          <Button text="相談してみる" href="/contact/" red="red" />
        </div>
      </div>
    </section>
  )
}

export default TopStrengths
